import React, { useEffect, useState } from "react";
import { PlaceOutlined } from "@mui/icons-material";
import { api } from "../../services/api";
import "./mapaEvento.css";

/* Mapa embebido de la ubicación del evento.
 *
 * Encapsula el pedido del embed y los estados intermedios: mientras falten
 * datos muestra una invitación a completarlos, y mientras carga muestra un
 * placeholder animado en vez de un iframe vacío. */
const MapaEvento = ({ direccion, ciudad, provincia, altura = 230 }) => {
  const [mapUrl, setMapUrl] = useState("");
  const [cargando, setCargando] = useState(false);

  const completo = Boolean(direccion?.trim() && ciudad);
  const consulta = [direccion, ciudad, provincia].filter(Boolean).join(" ");

  useEffect(() => {
    if (!completo) {
      setMapUrl("");
      return;
    }

    let cancelado = false;
    setCargando(true);

    const fetchMapa = async () => {
      try {
        const response = await api.maps.getEmbedURL(consulta);
        if (cancelado) return;

        if (response.status === "success") {
          setMapUrl(response.embedUrl);
        } else {
          console.error("Error al obtener el mapa:", response.message);
          setMapUrl("");
        }
      } catch (error) {
        if (!cancelado) {
          console.error("Error al obtener el mapa:", error);
          setMapUrl("");
        }
      } finally {
        if (!cancelado) setCargando(false);
      }
    };

    fetchMapa();
    return () => {
      cancelado = true;
    };
  }, [consulta, completo]);

  if (mapUrl) {
    return (
      <iframe
        title={`Mapa de ${direccion}, ${ciudad}`}
        className="rounded shadow mapa-evento"
        width="100%"
        height={altura}
        id="map"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={mapUrl}
      />
    );
  }

  return (
    <div
      className={`mapa-evento-placeholder ${cargando ? "cargando" : ""}`}
      style={{ height: altura }}
    >
      <PlaceOutlined className="mapa-evento-pin" />
      <p className="mapa-evento-texto">
        {cargando
          ? "Buscando la ubicación…"
          : "Completá provincia, ciudad y dirección para ver el mapa"}
      </p>
    </div>
  );
};

export default MapaEvento;
